import remarkGfm from "remark-gfm";
import remarkParse from "remark-parse";
import remarkStringify from "remark-stringify";
import stripMarkdown from "strip-markdown";
import { unified } from "unified";

const processor = unified().use(remarkParse).use(remarkGfm).use(stripMarkdown).use(remarkStringify);

// remark-stringify separates block nodes with a blank line, and strip-markdown has
// already flattened list items into blocks of their own.
const BLOCK_BOUNDARY = /\n{2,}/;

// The blocks arriving without terminal punctuation are the headings and list items.
const ENDS_A_SENTENCE = /[.!?:;,]$/;

/**
 * Flatten a markdown string to plain text for dense previews (cards, list rows).
 *
 * Parses GFM (matching how detail pages render) and strips all formatting —
 * headings, emphasis, strikethrough, code, lists, link urls (label kept), image
 * markup (alt text kept). Tables are dropped entirely, and no literal `#`, `*`,
 * `~`, or `|` survives. Render real markdown on detail pages, not here.
 *
 * Blocks are rejoined onto one line with a separator between them, so a heading
 * and the list items under it read as separate things.
 */
export const stripMarkdownToText = (markdown: string): string =>
  String(processor.processSync(markdown))
    .split(BLOCK_BOUNDARY)
    .map((block) => block.replace(/\s+/g, " ").trim())
    .filter(Boolean)
    .reduce(
      (text, block) =>
        text ? `${text}${ENDS_A_SENTENCE.test(text) ? " " : " \u00b7 "}${block}` : block,
      ""
    );
